import { parseUrlState } from "components/my_feed/useMyFeedPageState";
import { useURLState } from "lib/hooks/useURLState";
import { EMPTY_FILTERS, NoticeColumns, NoticeFilters } from "./utils";

export function useFilterableNoticeTableState() {
  const [noticeTableFilters, setNoticeTableFilters] = useURLState<NoticeFilters | undefined>(
    "noticeFilters",
    EMPTY_FILTERS,
    (val) => parseUrlState(val as NoticeFilters, EMPTY_FILTERS),
  );

  const [noticeTableColumns, setNoticeTableColumns] = useURLState<NoticeColumns[] | undefined>(
    "noticeColumns",
    undefined,
  );

  let tableColumns: NoticeColumns[] | undefined;
  if (noticeTableColumns) {
    tableColumns = noticeTableColumns as NoticeColumns[];
  } else {
    tableColumns = undefined;
  }

  return {
    noticeTableFilters,
    setNoticeTableFilters,
    noticeTableColumns,
    setNoticeTableColumns,
    tableColumns,
  };
}
